import palette from '../../palette';

export default {
  root: {
    color: `${palette.white} !important`,
    "&:hover": {
      color: palette.white
    }
  },
  icon: {
    fill: palette.white
  }
};
